import { render, staticRenderFns } from "./NoticeDiscontinuance.vue?vue&type=template&id=7a462a82"
import script from "./NoticeDiscontinuance.vue?vue&type=script&lang=ts"
export * from "./NoticeDiscontinuance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports